module.exports = __webpack_public_path__ + "static/media/pdbMenuFoldOut_Mobile.7efb63f4.png";